{
  "title": "Categories",
  "description": "Barrel and jerrycan categories used in operations",
  "columns": {
    "name": "Name",
    "type": "Type",
    "fraction": "Numeric value"
  },
  "type": {
    "BARREL": "Barrel",
    "JERRYCAN": "Jerrycan"
  },
  "actions": {
    "add": "Add Category",
    "delete": "Delete"
  },
  "list": {
    "ariaLabel": "Categories",
    "emptyTitle": "No data available",
    "emptyAction": "Add the first category"
  },
  "drawer": {
    "createTitle": "Add Category",
    "fields": {
      "type": "Type",
      "nameAr": "Arabic Name",
      "nameEn": "English Name",
      "fraction": "Numeric value"
    },
    "submit": "Add",
    "cancel": "Cancel",
    "discard": {
      "title": "Discard changes?",
      "description": "What you entered for this category will not be saved.",
      "confirmLabel": "Discard",
      "cancelLabel": "Keep editing"
    }
  },
  "deleteConfirm": {
    "title": "Delete {{name}}?",
    "description": "This category will be permanently deleted. This action cannot be undone.",
    "confirm": "Delete"
  },
  "toasts": {
    "created": "Category created successfully",
    "deleted": "Category deleted successfully"
  },
  "validation": {
    "mustBePositive": "The value must be greater than zero",
    "tooManyDecimals": "At most five decimal places are allowed."
  }
}
